import React, { Component } from 'react'
import { Link } from 'react-router';
import CheckboxList from '../../../../containers/Sections/Menu/SearchMenu/checkboxList'
import { Col, FormGroup, DropdownButton, MenuItem } from 'react-bootstrap'

export default class MoreFilters extends Component {

	render(){

		const { first, second, third} = this.props

		return (
			<div className="ljr-menu-search-more-filters row-normal">
    		{ (first.options.length > 0) ? (
	      	<Col md={4}>
      			{first.options.map((item, index) =>
      				this._renderColumnOptions(item)
    				)}
			    </Col>
		    ) : '' }
    		{ (second.options.length > 0) ? (
	      	<Col md={4}>
      			{second.options.map((item, index) =>
      				this._renderColumnOptions(item)
    				)}
			    </Col>
		    ) : '' }
		    { (third.options.length > 0) ? (
	      	<Col md={4}>
      			{third.options.map((item, index) =>
      				this._renderColumnOptions(item)
    				)}
			    </Col>
		    ) : '' }
	    </div>
		)
	}

	_renderColumnOptions(item, changeCheckValue) {
		let result = ''
		if (item.type === "dropdown"){
			result = (
				<FormGroup>
    			<p className="drop-title">{item.name}</p>
					{this._renderOptions(item.selected, item.list, item.onSelect)}
	    	</FormGroup>
    	)
		}
		else if (item.type === "checkbox-list-numbers"){
			if ((item.name === 'Ambientes') || (item.name === 'Dormitorios')) { 
				result = (
					<FormGroup className="shownTablet">
	  				<CheckboxList array={item.array} item={item}/>
			    </FormGroup>
				)
			}
			else{
				result = (
					<FormGroup>
	  				<CheckboxList array={item.array} item={item}/>
			    </FormGroup>	
		    )
			}
		}
		else{
			if (item.name){
				result = (
					<FormGroup className="horizontal-group">
						<CheckboxList item={item} />
					</FormGroup>
				)
			}
			else{
				result = (
					<FormGroup className="horizontal-group col-md-6">
						<CheckboxList item={item} />
					</FormGroup>
				)
			}

		}
		return result;
	}

	_renderOptions(selected, options, onSelect) {
		let title = ''
		if(options.length){
			if(options[0].id != ''){
				options.unshift({id: '', 'name':'-'})
			}
		}

		if (selected){
			title = ''
			title = (selected.length > 0) ? selected[0].name : "Seleccionar"
		}

		let onSelectOption = (value) => {
				onSelect(value);			
		}

   	return (
	   	<DropdownButton title={title} id="dropdown-in-options" onSelect={onSelectOption} >
				{options.map((item, index) =>
          <MenuItem eventKey={item} key={index}>{item.name}</MenuItem>
        )}
	    </DropdownButton>
	 	)
  }
}



// WEBPACK FOOTER //
// ./src/features/commons/Menu/SearchMenu/moreFilters.js